import React, { useState, useEffect } from "react";

import RequestHandler from "util/RequestHandler";
import { ColumnHelper, RowHelper } from "util/TableHelper";

import PaymentRequestListTableFilter from "../Filters/PaymentRequetsListTableFilter";
import PaymentRequestSendMailForm from "../Forms/PaymentRequestSendMailForm";
import moment from "moment";
import Screen from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";
import {
  Table,
  Empty,
  Col,
  Row,
  Tooltip,
  message,
  Modal,
  Popconfirm,
  DatePicker,
} from "antd";
import {
  BarsOutlined,
  CheckCircleOutlined,
  SendOutlined,
  CloseCircleOutlined,
  ReloadOutlined,
  CopyOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { odata } from "../Filters/Helper";

const PaymentList = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [sendMailModal, setSendMailModal] = useState({
    visible: false,
    data: null,
  });
  const [order, setOrder] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const renderDetailString = (text) => (text ? text : "-");
  const [
    b2BIsUseAdditionalFieldForPolicy,
    setB2BIsUseAdditionalFieldForPolicy,
  ] = useState(false);

  useEffect(() => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setB2BIsUseAdditionalFieldForPolicy(
          response.b2BIsUseAdditionalFieldForPolicy
        );
      }
    });
  }, []);
  useEffect(() => getTableData(), [order, tableDataQueryOptions]);

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/PaymentRequest?$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };
  const copyToLink = (paymentGuid) => {
    RequestHandler.get(`/PaymentRequest/GetDecodeUrl/${paymentGuid}`).then(
      (response) => {
        message.success("Link Kopyalandı.");
        navigator.clipboard.writeText(
          config.frontEndUrl + "PaymentPage?paymentGuid=" + response
        );
      }
    );
  };

  const onClickReload = (id, date) => {
    RequestHandler.post(
      `/PaymentRequest/RepeatPaymentRequest`,
      {
        Id: id,
        validityDate: date,
      },
      true
    ).then((response) => {
      window.location.reload();
    });
  };
  const onClickSendMail = (paymentGuid, eMail, screen) => {
    setSendMailModal({
      visible: true,
      data: { paymentGuid: paymentGuid, eMail: eMail, screen: screen },
    });
  };
  const handleDelete = (key) => {
    RequestHandler.delete(`/PaymentRequest?id=${key}`, true).then(
      (response) => {
        if (response?.success) {
          setTableData({
            data: tableData.data.filter((item) => item.id !== key),
            total: tableData.total - 1,
            loading: false,
          });
        }
      }
    );
  };

  const columns = [
    {
      title: "Email",
      dataIndex: "eMail",
    },
    {
      title: "Tutar",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      sorter: true,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      align: "center",
      dataIndex: "currencyCode",
    },
    {
      title: "Taksit Sayısı",
      align: "center",
      dataIndex: "installmentCount",
    },
    {
      title: "İşlem Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      sorter: true,
      align: "center",
      render: (data) => moment(data).format("DD.MM.YYYY HH:mm"),
    },
    {
      title: "Talebi Açan",
      dataIndex: "addUserName",
      key: "addUserName",
      align: "center",
      render: (data, row) => {
        return row.isFromB2b ? row.firmName + " (Bayi)" : data;
      },
    },
    {
      title: "Ödeme Tarihi",
      dataIndex: "updateDate",
      key: "updateDate",
      sorter: true,
      align: "center",
      render: (data, row) => {
        return !row.isPaid ? "-" : moment(data).format("DD.MM.YYYY HH:mm");
      },
    },
    {
      title: "Geçerlilik Tarihi",
      dataIndex: "validityDate",
      key: "validityDate",
      align: "center",
      render: (data, row) => {
        if (data === null) {
          return "-";
        } else {
          const isPastDate = moment(data).isBefore(moment(), "day");
          return (
            <span
              style={{ color: isPastDate && !row.isPaid ? "red" : "inherit" }}
            >
              {moment(data).format("DD.MM.YYYY")}
            </span>
          );
        }
      },
    },
    b2BIsUseAdditionalFieldForPolicy
      ? {
          title: "Sigorta Şirketi",
          dataIndex: "paymentMethod",
          render: renderDetailString,
        }
      : {},
    {
      title: "İşlem Sonucu",
      dataIndex: "success",
      align: "center",
      render: (data, row) => {
        return row.isPaid ? (
          <Tooltip title={"Ödendi"}>
            <CheckCircleOutlined style={{ color: "green", fontSize: "130%" }} />
          </Tooltip>
        ) : (
          <Tooltip title={"Ödenmedi"}>
            <CloseCircleOutlined style={{ color: "red", fontSize: "130%" }} />
          </Tooltip>
        );
      },
    },
    {
      title: "Tekrarla",
      dataIndex: "repeat",
      align: "center",
      render: (data, row) => (
        <Popconfirm
          title="Ödeme talebini tekrarlamak istediğinize emin misiniz?"
          onConfirm={() => {
            setSelectedRowId(row.id);
            setIsModalVisible(true);
          }}
          okText="Evet"
          cancelText="İptal"
        >
          <a>
            <ReloadOutlined style={{ fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
    {
      title: "Mail Gönder",
      dataIndex: "sendMail",
      align: "center",
      render: (data, row) =>
        !row.isPaid ? (
          <Popconfirm
            title="Ödeme linkini tekrar mail ile göndermek istediğinize emin misiniz?"
            onConfirm={() => {
              onClickSendMail(row.paymentGuid, row.eMail, Screen.screen);
            }}
            okText="Evet"
            cancelText="İptal"
          >
            <a>
              <SendOutlined style={{ fontSize: "130%" }} />
            </a>
          </Popconfirm>
        ) : null,
    },

    {
      title: "Link Kopyala",
      dataIndex: "copyLink",
      align: "center",
      render: (data, row) => (
        <a
          onClick={() => {
            copyToLink(row.paymentGuid);
          }}
        >
          <CopyOutlined style={{ fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "operation",
      width: "1%",
      render: (text, record) =>
        tableData.data.length >= 1 ? (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleDelete(record.id)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <DeleteOutlined />
            </a>
          </Popconfirm>
        ) : null,
    },
  ].filter(Boolean);

  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleOk = () => {
    onClickReload(selectedRowId, selectedDate);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const detailColumns = [
    {
      title: "Açıklama",
      dataIndex: "description",
      render: renderDetailString,
    },
  ];

  return (
    <>
      <Row>
        <Col xs={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined />
            LİNKLE ÖDEME TAKİBİ
          </p>
        </Col>
        <Col xs={8}>
          <Row justify="end" align="middle" style={{ paddingRight: 16 }}></Row>
        </Col>
      </Row>

      <PaymentRequestListTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        b2BIsUseAdditionalFieldForPolicy={b2BIsUseAdditionalFieldForPolicy}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
      <Modal
        id="sendMail"
        centered
        visible={sendMailModal.visible}
        onCancel={() => setSendMailModal({ visible: false, data: null })}
        footer={null}
      >
        <PaymentRequestSendMailForm
          data={sendMailModal.data}
          onFinish={() => setSendMailModal({ visible: false, data: null })}
        />
      </Modal>
      <Modal
        title="Geçerlilik Tarihi (Zorunlu değil)"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <DatePicker
          onChange={handleDateChange}
          format="DD.MM.YYYY"
          style={{ width: "100%" }}
          disabledDate={disabledDate}
        />
      </Modal>
    </>
  );
};

export default PaymentList;
